import React from 'react'
import { Card, PageHeader } from '@biartbt/biartd'

type PlaceholderPageProps = {
  title: string
  description?: string
}

/**
 * Placeholder for system data-template pages not yet implemented.
 * Replace with real page when backend/UI is ready.
 */
export default function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <PageHeader title={title} subtitle={description} />
      <Card className="p-8 text-center text-neutral-500">
        <p>Bu sayfa henüz hazırlanıyor.</p>
        {description && <p className="mt-2 text-sm">{description}</p>}
      </Card>
    </div>
  )
}
